import React from "react";
import { LinearProgress as MUILinearProgress } from "@mui/material";
import styled from "styled-components";

const StyledMUILinearProgress = styled(MUILinearProgress)`
  height: 8px !important;
  border-radius: 5px;
  ${({ backgroundcolor }) =>
    backgroundcolor ? `background-color:${backgroundcolor} !important;` : ""}

  span[class*="MuiLinearProgress-bar"] {
    ${({ coloroverride }) =>
      coloroverride ? `background-color:${coloroverride} !important;` : ""}
  }
`;

export const LinearProgress = ({
  color = "success",
  variant = "determinate",
  value,
  colorOverride = null,
  backgroundcolor = "var(--colorDivider)",
  title = `progress - ${value}`,
}) => {
  return (
    <StyledMUILinearProgress
      color={color}
      variant={variant}
      value={value}
      title={title}
      aria-label={title}
      coloroverride={colorOverride}
      backgroundcolor={backgroundcolor}
    />
  );
};
